// extracted by mini-css-extract-plugin
export var typingIndicator = "_lu-0";